import React, { useEffect, useState } from 'react';
import {
  TableRow,
  TableCell,
  Paper,
  AvatarGroup,
  Avatar,
  Dialog,
  DialogContent,
  IconButton,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import Table from '../../../components/Table';

import { TableResponse } from '../../../schema/helper';
import { api } from '../../../api';
import { formatDate } from '../../../util';
import dayjs from 'dayjs';

interface NumberInOut {
  personal_id: string;
  person_id: number;
  company_id: number;
  status_id: number;
  gate_id: number;
  person_type_id: number;

  name: string;
  person_type: string;
  company: string;
  status: string;
  gate: string;
  area: string;
  created_time: string;
}
interface TableInOutEachGateProps {
  filterID: string;
  filterName: string;
  filterGateIDList: number[];
  filterAreaIDList: number[];
  filterCompanyIDList: number[];
  filterPersonTypeIDList: string[];
  filterScanTypes: string[];
  filterStartDate: Date | null;
  filterEndDate: Date | null;
  filterGateGroupIDList: number[];
}
const tableHead = [
  // 'ภาพบุคคล',
  'เลขประจำตัวประชาชน',
  'ชื่อ นามสกุล',
  'ประเภทบุคคล',
  'บริษัท',
  'เวลา',
  'ประตู',
  'พื้นที่',
  'เข้าออก'
];
const TableInOutEachGate: React.FC<TableInOutEachGateProps> = ({
  filterID,
  filterName,
  filterGateIDList,
  filterAreaIDList,
  filterCompanyIDList,
  filterPersonTypeIDList,
  filterScanTypes,
  filterStartDate,
  filterEndDate,
  filterGateGroupIDList
}: TableInOutEachGateProps) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState<TableResponse<NumberInOut> | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedPhoto, setSelectedPhoto] = useState<string | null>(null);
  const [selectedName, setSelectedName] = useState<string>('');
  const defaultPhotoURL =
  'https://fuse-react-vitejs-demo.fusetheme.com/assets/images/avatars/male-14.jpg';

  const defaultPhotoURL2 =
  'https://media.geeksforgeeks.org/wp-content/uploads/20251220111559814831/Face_reco1.jpeg';

  const handleOpenPhoto = (photoUrl: string, name: string) => {
    setSelectedPhoto(photoUrl);
    setSelectedName(name);
  };

  const handleClosePhoto = () => {
    setSelectedPhoto(null);
    setSelectedName('');
  };

  const handlePageChange = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    setPage(0);
  }, [
    filterID,
    filterName,
    filterGateIDList,
    filterAreaIDList,
    filterCompanyIDList,
    filterPersonTypeIDList,
    filterScanTypes,
    filterStartDate,
    filterEndDate,
    filterGateGroupIDList
  ]);

  useEffect(() => {
    setIsLoading(true);
    const timeOutId = setTimeout(() => {
      const searchParams = new URLSearchParams();

      if (filterID) {
        searchParams.set('personal_id', `${filterID}`);
      }
      if (filterName) {
        searchParams.set('name', `${filterName}`);
      }
      if (filterGateIDList) {
        filterGateIDList.forEach((gate_id) => {
          searchParams.append('gate_id', `${gate_id}`);
        });
      }
      if (filterGateGroupIDList) {
        filterGateGroupIDList.forEach((gategroup_id) => {
          searchParams.append('gategroup_id', `${gategroup_id}`);
        });
      }
      if (filterAreaIDList) {
        filterAreaIDList.forEach((area_id) => {
          searchParams.append('area_id', `${area_id}`);
        });
      }
      if (filterCompanyIDList.length) {
        filterCompanyIDList.forEach((company_id) => {
          searchParams.append('company_id', `${company_id}`);
        });
      }
      if (filterPersonTypeIDList.length) {
        filterPersonTypeIDList.forEach((person_type_id) => {
          searchParams.append('person_type_id', `${person_type_id}`);
        });
      }
      if (filterScanTypes.length) {
        filterScanTypes.forEach((type_id) => {
          searchParams.append('type_id', `${type_id}`);
      });
    }
      if (filterStartDate) {
        searchParams.set('start_date', `${filterStartDate.toISOString()}`);
      }
      if (filterEndDate) {
        searchParams.set('end_date', `${filterEndDate.toISOString()}`);
      }

      searchParams.set('offset', `${page * rowsPerPage}`);
      searchParams.set('limit', `${rowsPerPage}`);
      api.get<TableResponse<NumberInOut>>(`/scan-in-out`, { params: searchParams }).then((res) => {
        const { data } = res;
        setData(data);
      })
      .finally(() => setIsLoading(false));
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [
    filterID,
    filterName,
    filterGateIDList,
    filterAreaIDList,
    filterCompanyIDList,
    filterPersonTypeIDList,
    filterScanTypes,
    filterStartDate,
    filterEndDate,
    filterGateGroupIDList,
    page,
    rowsPerPage
  ]);

  return (
    <>
      <Paper>
        <Table
          heads={tableHead}
          count={data?.total ? data?.total : 0}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          isLoading={isLoading}
        >
          {data?.data.map((data, index) => (
            <TableRow key={index}>
              {/* <TableCell align="center">
                <AvatarGroup spacing={24}>
                  {[defaultPhotoURL2, defaultPhotoURL].map((photoUrl, avatarIndex) => (
                    <Avatar
                      key={`${data.personal_id}-${avatarIndex}`}
                      src={photoUrl}
                      alt={`${data.name}-${avatarIndex}`}
                      onClick={() => handleOpenPhoto(photoUrl, data.name)}
                      sx={{
                        width: 56,
                        height: 56,
                        cursor: 'pointer',
                        border: '2px solid #fff',
                        '&:hover': {
                          transform: 'scale(1.08)',
                          transition: 'transform 0.2s ease-in-out'
                        }
                      }}
                    />
                  ))}
                </AvatarGroup>
              </TableCell> */}
              <TableCell align="center">{data.personal_id}</TableCell>
              <TableCell align="center">{data.name}</TableCell>
              <TableCell align="center">{data.person_type}</TableCell>
              <TableCell align="center">{data.company}</TableCell>
              {/* <TableCell align="center">{new Date(data.created_time).toLocaleString()}</TableCell> */}
              <TableCell align="center">
                {dayjs(data.created_time).format('DD/MM/YYYY | HH:mm')}
              </TableCell>
              <TableCell align="center">{data.gate}</TableCell>
              <TableCell align="center">{data.area}</TableCell>
              <TableCell align="center">{data.status}</TableCell>
            </TableRow>
          ))}
        </Table>
      </Paper>

      <Dialog
        open={Boolean(selectedPhoto)}
        onClose={handleClosePhoto}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden',
            backgroundColor: '#f5f5f5'
          }
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
          <IconButton aria-label="close photo" onClick={handleClosePhoto}>
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2, pt: 0 }}>
          <Box
            component="img"
            src={selectedPhoto ?? undefined}
            alt={selectedName || 'Person photo'}
            sx={{
              maxWidth: '100%',
              maxHeight: '75vh',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
              borderRadius: 2,
              boxShadow: 3,
              backgroundColor: '#fff'
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TableInOutEachGate;
